"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.nullableArray = exports.object = exports.at = exports.fieldOr = exports.field = exports.dict = exports.noEmptyArray = exports.array = exports.nullable = exports.optional = exports.defaultValue = exports.safe = exports.decodeJson = void 0;
const BasicDecode = __importStar(require("./basicDecode"));
const errors_1 = require("./errors");
const decodeJson = (decodeFn, json) => {
    try {
        return decodeFn(json);
    }
    catch (error) {
        // log error in pre-productive environments
        console.error(error);
        // Here we could log errors that occur on the client due to invalid API responses
        // Sentry.captureException(error);
        throw error;
    }
};
exports.decodeJson = decodeJson;
const safe = (value, decode) => {
    return function (json) {
        try {
            return decode(json);
        }
        catch (_a) {
            return value;
        }
    };
};
exports.safe = safe;
const defaultValue = function (value, decode) {
    return function (json) {
        return json === null || json === undefined ? value : decode(json);
    };
};
exports.defaultValue = defaultValue;
const optional = (decode) => (0, exports.defaultValue)(undefined, decode);
exports.optional = optional;
const nullable = decode => (0, exports.defaultValue)(null, decode);
exports.nullable = nullable;
const array = decode => {
    return function (json) {
        if (!Array.isArray(json)) {
            throw new errors_1.DecodeError('Expected array, got ' + JSON.stringify(json));
        }
        return json.map(function (value, index) {
            try {
                return decode(value);
            }
            catch (error) {
                throw new errors_1.DecodeError(`${error}\n\tin array at index ${index}`);
            }
        });
    };
};
exports.array = array;
const isNotEmpty = arr => arr.length > 0;
const noEmptyArray = decode => BasicDecode.map((0, exports.array)(decode), function (items) {
    if (isNotEmpty(items)) {
        return items;
    }
    throw new errors_1.DecodeError('Expected no empty array');
});
exports.noEmptyArray = noEmptyArray;
const throwExpectedObjectError = (json) => {
    throw new errors_1.DecodeError(`Expected object, got ${JSON.stringify(json)}`);
};
const dict = decode => {
    return function (json) {
        if (typeof json !== 'object' || Array.isArray(json) || json === null) {
            throwExpectedObjectError(json);
        }
        return Object.keys(json).reduce(function (target, key) {
            try {
                return target.set(key, decode(json[key]));
            }
            catch (error) {
                throw new errors_1.DecodeError(`${error}\n\tin dict`);
            }
        }, new Map());
    };
};
exports.dict = dict;
const field = (key, decode) => {
    return function (json) {
        if (Array.isArray(json) || json === null || typeof json !== 'object') {
            throwExpectedObjectError(json);
        }
        try {
            return decode(json[key]);
        }
        catch (error) {
            throw new errors_1.DecodeError(`${error}\n\tat field "${key}"`);
        }
    };
};
exports.field = field;
const fieldOr = (keys, decode) => {
    return function (json) {
        if (Array.isArray(json) || json === null || typeof json !== 'object') {
            throwExpectedObjectError(json);
        }
        const key = keys.find(k => json[k] !== undefined);
        if (key === undefined) {
            throw new errors_1.DecodeError(`Expected got ${JSON.stringify(json)} one of [${keys.join(', ')}]`);
        }
        try {
            return decode(json[key]);
        }
        catch (error) {
            throw new errors_1.DecodeError(`${error}\n\tat field "${key}"`);
        }
    };
};
exports.fieldOr = fieldOr;
const at = (keyPath, decode) => {
    if (keyPath.length === 0) {
        throw new Error('Expected keyPath to contain at least one element');
    }
    if (keyPath.length === 1) {
        return (0, exports.field)(keyPath[0], decode);
    }
    return (0, exports.field)(keyPath[0], (0, exports.at)(keyPath.slice(1), decode));
};
exports.at = at;
const object = def => {
    return function (json) {
        const result = {};
        for (const dk in def) {
            // eslint-disable-next-line no-prototype-builtins
            if (def.hasOwnProperty(dk)) {
                const decode = def[dk];
                result[dk] = decode(json);
            }
        }
        return result;
    };
};
exports.object = object;
const nullableArray = (decode) => (0, exports.defaultValue)([], (0, exports.array)(decode));
exports.nullableArray = nullableArray;
//# sourceMappingURL=advanceDecode.js.map